import { gql } from "@apollo/client";

export const signEula = gql`
    mutation signEula($eulaId: String!) {
        signEULA(input: { eulaId: $eulaId }) {
            hasAgreedToLatestEula
        }
    }
`;
